import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux';

import User from './views/user';
import ActivateAccount from './views/activateAccount';

import { setNotification } from './utils/helpers';

const App = () => {

  const generalsInfo = useSelector((state) => state.generals);
  useEffect(() => {
    if (Object.keys(generalsInfo.notifications).length > 0){
      setNotification(generalsInfo.notifications);
    }
  }, [generalsInfo.notifications])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<User/>} />
        <Route exact path="/activate" element={<ActivateAccount />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
